import React from 'react';

import Link from '@marvelapp/marvel-ui/link';

const faqItems = [
  {
    id: 0,
    question: 'What happens if I add more team members to my plan?',
    answer: (
      <span>
        Additional team members can be added or removed at any time. The cost of
        each new team member will be pro-rated and charged based on the billing
        schedule you've selected (monthly or yearly).
      </span>
    ),
  },
  {
    id: 1,
    question: `How are Team Members and Contributors different?`,
    answer: (
      <span>
        Team Members have access to all projects within your Marvel account
        (great for employees). There is a per user charge for Team Members.
        Contributors can only see projects they have been specifically invited
        to (Great for freelancers). Contributors are included with your plan.
      </span>
    ),
  },
  {
    id: 2,
    question: 'Can I cancel or switch at any time?',
    answer: (
      <span>
        Yes! You can manage your plan 24/7 in your account section. Any
        downgrades are immediate and we do not offer refunds for unused time on
        your monthly or yearly plan.
      </span>
    ),
  },
  {
    id: 3,
    question: 'What payment methods does Marvel accept?',
    answer: (
      <span>
        We accept Visa, Mastercard and American Express. Our Enterprise plan
        allows you to pay by invoice or bank transfer.
      </span>
    ),
  },
  {
    id: 4,
    question: 'Do you have discounts for students and non-profits?',
    answer: (
      <span>
        Yes! Up to 70%! In both cases, we require some additional verification
        information. Read more{' '}
        <Link
          url="https://help.marvelapp.com/hc/en-us/articles/360003458197"
          target="_blank"
          type="blue"
        >
          here
        </Link>
        .
      </span>
    ),
  },
  {
    id: 5,
    question: 'How do I purchase more than 6 team members?',
    answer: (
      <span>
        Our Enterprise plan has no limit on team members. Speak to the{' '}
        <Link url="/enterprise/request-demo" type="blue">
          team
        </Link>{' '}
        for a demo and quote based on your needs.
      </span>
    ),
  },
  {
    id: 6,
    question: 'Does Marvel have any time-limits or trials?',
    answer: (
      <span>
        Our free plan has no time-limits so you can use Marvel for as long as
        you need before deciding to upgrade.
      </span>
    ),
  },
  {
    id: 7,
    question: 'How secure is Marvel?',
    answer: (
      <span>
        Drop us a line{' '}
        <Link
          url="https://help.marvelapp.com/hc/en-us/requests/new"
          target="_blank"
          type="blue"
        >
          here
        </Link>
        .
      </span>
    ),
  },
];

export default faqItems;



// WEBPACK FOOTER //
// ./src/configs/pages/pricing/faq.js